module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"my_areas":"Mes pièces","find":"Rechercher","area_in_alert":"Pièces en alerte","building_offline":"Bâtiment hors ligne"},"en":{"my_areas":"My areas","find":"Find","area_in_alert":"Areas with alerts","building_offline":"Building is offline"}}')
  delete Component.options._Ctor
}
